module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gD73G"))).then(() => module.bundle.root('aVi2q'));